import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	resetButton: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.zoom-bar.reset-button',
		defaultMessage: 'Reset',
		description: 'Label for reset zoom button',
	},
	fitButton: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.zoom-bar.fit-button',
		defaultMessage: 'Fit',
		description: 'Label for fit zoom button (set zoom to show all issues)',
	},
	zoomIn: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.zoom-bar.zoom-in',
		defaultMessage: 'Zoom In',
		description: 'Accessible label for zoom in icon',
	},
	zoomOut: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.zoom-bar.zoom-out',
		defaultMessage: 'Zoom Out',
		description: 'Accessible label for zoom out icon',
	},
});
